export default {_name:'checkbox.group',module:'Field',view:'Element/Field/Group/Check',options:{xs:12},mobileOptions:{ms:12}}